<template lang="pug">
    multiselect(
        :value="value"
        :options="categoryBusinesses"
        label="name"
        track-by="name"
        name="categoryBusiness"
        @input="onInput"
        :disabled="disabled"
    )
        template(slot="option" slot-scope="props")
            span.block {{ props.option.name }}
</template>

<script>
import categoryBusiness from '@js/store/modules/categoryBusiness';
import { mapActions, mapGetters } from 'vuex';

export default {
    props: {
        value: {
            type: null,
            default: () => null,
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        ...mapGetters('categoryBusiness', ['categoryBusinesses']),
    },

    beforeCreate() {
        if (!this.$store.hasModule('categoryBusiness')) {
            this.$store.registerModule('categoryBusiness', categoryBusiness);
        }
    },

    mounted() {
        this.getCategoryBusinesses();
    },

    methods: {
        ...mapActions('categoryBusiness', ['getCategoryBusinesses']),

        onInput(value) {
            this.$emit('input', value);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CategoryBusinessSelector.vue